import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { AuthContext } from '../../shared/context/auth-context';
import Like from '../../shared/components/FormElements/like';
import CourseModal from '../../shared/components/UIElements/courseModal';
import Share from '../../shared/components/FormElements/share';
import Comment from '../../shared/components/FormElements/comment';

import './postDetails.css';

const PostDetails = () => {

    const { user } = useContext(AuthContext)
    const { postId } = useParams();

    const [postDetail, setPostDetail] = useState(null)
    const [error, setError] = useState(null)
    const [open, setOpen] = useState(false);

    
    useEffect(() => {
        const detailFetch = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/posts/${postId}`)
                const responseData = await response.json(); 
                
                if (!response.ok) {
                    throw new Error(responseData.message || 'Failed to fetch post. ')
                };

                setPostDetail(responseData.post);
            } catch(err) {
                setError(err.message)
            }
            
        };

        detailFetch();

    }, [postId]);

    const handleOpen = (postId) => setOpen(postId);
    const handleClose = () => setOpen(false);

   
    // Time Format
    const timeHandler = (createdAt) => {
    const now = new Date();
    const postTime = new Date(createdAt);
    const diffInSeconds = Math.floor((now - postTime) / 1000);

    if (diffInSeconds < 60){
        return `${diffInSeconds}s`;
    } else if (diffInSeconds < 3600) {
        const minutes = Math.floor(diffInSeconds / 60)
        return `${minutes}m`;
    } else if (diffInSeconds < 86400) {
        const hour = Math.floor(diffInSeconds / 3600);
        return `${hour}h`;
    } else {
        const days = Math.floor(diffInSeconds / 86400);
        return `${days}d`;
    }
  }

  if(error) return <div>Error: {error}</div>;
  if (!postDetail)  return <div>Loading post...</div>;
   
    const post = postDetail;


    return (
        <main className='post-detail'>
        <div className='post-detail-container'>
            <h1>Post</h1>
         
          
              <div className='post-detail-controller' >

                <div className='post_creator_name'>
                  <img src={`${process.env.REACT_APP_ASSET_URL}/${post.creator.image}`} alt='p' title={post.creator.name} style={{margin: '0px 10px 10px 0px'}}/>
                  <div>
                    <div>{post.creator.name}</div>
                    <div style={{fontSize: '0.7rem'}}>
                      {timeHandler(post.createdAt)}
                    </div>
                  </div>
          
                </div>
                
                <h3>{post.title}</h3>
                <div className='post-image-container'>

                  {post.video ? (
                    <div className='post-image-controller'>
                    
                      <video controls width="100%" className='userPost-video'>
                        <source 
                          src={`${process.env.REACT_APP_ASSET_URL}/${post.video}`}   
                          type={`video/${post.video.split('.').pop()}`}
                          
                        />                           
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  ) : post.image ? (
                    <div className='post-image-controller'>
                      <img src={`${process.env.REACT_APP_ASSET_URL}/${post.image}`} alt='pic'/>
                    </div> 
                  ) : null }
                  
                  
                </div>
                <p>{post.post}</p>

                <footer className='post-footer'>
                  {/* Like */}
                  <div className='post-footer-like'>
                    <Like
                      postId={post._id} 
                      initialLikes={post.likes} 
                      isLikedByUser={post.likes.includes(user.id)}
                      className='footer-like'  
                    />
                  </div>

                  {/* Comment */}
                  <div className='post-footer-comment'>
                    <button 
                      className='footer-comment' 
                      onClick={() => handleOpen(post._id)}> 
                      {post.comments.length === 0
                        ? "Comment" 
                        : post.comments.length === 1 
                          ? "1 Comment"
                          : `${post.comments.length} Comments`
                      }
                    </button>
                  
                    {open === post._id && (
                        <CourseModal show={open} onCancel={handleClose}>
                            <Comment 
                                postId={post.id}
                            />
                        </CourseModal>
                    )}
                  </div>
                
                  {/* Share */}
                  <div className='post-footer-share'>
                    {/* <button 
                     
                      className='footer-share'>Share
                    </button> */}
                    
                     <Share
                          postId={post._id}
                          
                      />
                  </div>
             
                </footer>
              </div>
         
        </div>
        </main>
    )

}

export default PostDetails;